import { useSelector } from 'react-redux'

import { useDatadogUser } from '@emmacare/common/services/datadogRum'

import { userProfile$ } from 'src/store/modules/user'

const DatadogUserTracker = () => {
  const profile = useSelector(userProfile$)
  useDatadogUser(profile)

  return null
}

export default DatadogUserTracker
